/**
 * Things that happen to an *encounter* rather than to one aircraft. The
 * per-aircraft feed (`SimEventKind` — stalls, jams, wing failure, the pilot
 * dying) stays where it is; this is the layer above it, so a HUD can say
 * "ENEMY DESTROYED" without the flight core knowing what an enemy is.
 *
 * Every event carries the aircraft it is about, because an encounter has more
 * than one.
 */

export const COMBAT_EVENT_KINDS = [
  "roundsOnTarget",
  "takingHits",
  "engineSputtering",
  "onFire",
  "outOfControl",
  "destroyed",
  "encounterWon",
  "encounterLost",
] as const;

export type CombatEventKind = (typeof COMBAT_EVENT_KINDS)[number];

export interface CombatEvent {
  readonly kind: CombatEventKind;
  /** The aircraft the event is about. */
  readonly aircraftId: string;
  /** Who caused it, when that is meaningful (a hit, a kill). */
  readonly sourceId: string | null;
}

export function combatEvent(
  kind: CombatEventKind,
  aircraftId: string,
  sourceId: string | null = null,
): CombatEvent {
  return { kind, aircraftId, sourceId };
}
